import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Replicates AngularJS workflow grid: emptyGridJson?grid_id=106 (from workflow.js).
 */
@Injectable({ providedIn: 'root' })
export class WorkflowGridService {
  private readonly GRID_ID = 106;

  constructor(private http: HttpClient) {}

  loadGridData(
    baseUrl: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/emptyGridJson?grid_id=${this.GRID_ID}`;
    const globalParams = globalService?.globalParams ?? globalService ?? {};
    const params = { ...globalParams, ...filterParams };
    return this.http.get<any>(url, { params, withCredentials: true });
  }
}
